module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_01-de94f256788f2b7929e93359e5413106.svg";